import { useNavigate } from 'react-router-dom';

export default function HimalayaPartnershipPage() {
  const navigate = useNavigate();

  const handleTrialClick = () => {
    window.open('https://fas.st/t/8VSufVkH', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      {/* Main Content */}
      <main className="py-16 px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-6 mb-8">
              <img 
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/89118dbe19779d61d2b0de191ca595c7.png"
                alt="Himalaya Accounting Solutions Logo"
                className="h-32 w-32 object-contain"
              />
              <div className="w-px h-16 bg-orange-500/30"></div>
              <img 
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/e200ded0512fa4f1c42cf2a76268a351.webp"
                alt="AI Tax Software Logo"
                className="h-24 w-auto object-contain"
              />
            </div>
            
            <div className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full bg-gradient-to-r from-orange-500 to-orange-600 border border-orange-400 mb-8 shadow-lg shadow-orange-500/20">
              <i className="ri-vip-crown-line text-white text-lg"></i>
              <span className="text-sm text-white font-bold tracking-wide">EXCLUSIVE HIMALAYA MEMBER OFFER</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight tracking-tight">
              Transform Your Tax Practice with <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">AI-Powered Automation</span>
            </h1>
            
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8">
              As a valued Himalaya community member, you're invited to experience revolutionary AI tax software with an <strong className="text-orange-400">exclusive 7-day free trial</strong>. Discover how 45+ specialized AI agents can transform your tax preparation workflow.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={handleTrialClick}
                className="inline-flex items-center cursor-pointer justify-center gap-3 whitespace-nowrap bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:from-orange-600 hover:to-orange-700 text-lg font-bold px-10 h-16 rounded-xl shadow-2xl shadow-orange-500/30 transition-all duration-300 hover:scale-105"
              >
                <i className="ri-gift-line text-2xl"></i>
                Claim Your 7-Day Free Trial
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>

            <div className="flex items-center justify-center gap-8 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                <span>No Credit Card Required</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                <span>Full Access to All Features</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-orange-500"></i>
                <span>Cancel Anytime</span>
              </div>
            </div>
          </div>

          {/* Video Container */}
          <div className="bg-gradient-to-br from-orange-500/10 to-orange-600/5 rounded-3xl p-4 shadow-2xl border border-orange-500/20 mb-16">
            <div className="bg-black rounded-2xl overflow-hidden shadow-inner">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src="https://www.youtube.com/embed/XRjyZ1n1P8A"
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="AI Tax Software Demo Video"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Partnership Benefits */}
          <div className="mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white text-center mb-12">
              Why Himalaya Members <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">Love This Software</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-robot-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">45+ Specialized AI Agents</h3>
                <p className="text-gray-400 leading-relaxed">
                  Industry-specific AI experts trained to find additional deductions and savings opportunities across all business sectors
                </p>
              </div>

              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-file-list-3-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">30+ Tax Forms Automated</h3>
                <p className="text-gray-400 leading-relaxed">
                  Complete automation for 1040, 1065, 1120, and more. Federal and state returns handled seamlessly
                </p>
              </div>

              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">All 50 States Covered</h3>
                <p className="text-gray-400 leading-relaxed">
                  Multi-state tax projections and compliance management in one unified, intelligent platform
                </p>
              </div>

              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">Save 80% of Time</h3>
                <p className="text-gray-400 leading-relaxed">
                  Reduce manual data entry and error checking time dramatically with intelligent automation workflows
                </p>
              </div>

              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">IRS-Compliant Accuracy</h3>
                <p className="text-gray-400 leading-relaxed">
                  Built-in compliance checks and validation ensure every return meets federal and state requirements
                </p>
              </div>

              <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-orange-500/20 rounded-2xl p-8 hover:border-orange-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/10">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-line-chart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">Amendment Detection</h3>
                <p className="text-gray-400 leading-relaxed">
                  Automated 1040X preparation with AI-powered amendment finding to maximize client refunds
                </p>
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div className="mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white text-center mb-12">
              Get Started in <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">3 Simple Steps</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="relative">
                <div className="bg-gradient-to-br from-gray-800 to-gray-900 border-2 border-orange-500/30 rounded-2xl p-8 h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold text-white">1</span>
                    </div>
                    <h3 className="text-xl font-bold text-white">Claim Your Trial</h3>
                  </div>
                  <p className="text-gray-400 leading-relaxed">
                    Click the button above to activate your exclusive 7-day free trial. No credit card required.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-gray-800 to-gray-900 border-2 border-orange-500/30 rounded-2xl p-8 h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold text-white">2</span>
                    </div>
                    <h3 className="text-xl font-bold text-white">Explore Features</h3>
                  </div>
                  <p className="text-gray-400 leading-relaxed">
                    Access all 45+ AI agents, automated forms, and multi-state compliance tools immediately.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="bg-gradient-to-br from-gray-800 to-gray-900 border-2 border-orange-500/30 rounded-2xl p-8 h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-2xl font-bold text-white">3</span>
                    </div>
                    <h3 className="text-xl font-bold text-white">Transform Your Practice</h3>
                  </div>
                  <p className="text-gray-400 leading-relaxed">
                    Experience the power of AI automation and see why tax professionals are making the switch.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-12 text-center relative overflow-hidden shadow-2xl shadow-orange-500/30">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-5 py-2.5 rounded-full mb-6">
                <i className="ri-time-line text-white"></i>
                <span className="text-sm text-white font-semibold">Limited Time Offer for Himalaya Members</span>
              </div>
              
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
                Ready to Revolutionize Your Tax Workflow?
              </h2>
              
              <p className="text-xl text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed">
                Join hundreds of tax professionals who have already transformed their practice with AI-powered automation. Your exclusive 7-day trial awaits.
              </p>
              
              <button 
                onClick={handleTrialClick}
                className="inline-flex items-center cursor-pointer justify-center gap-3 whitespace-nowrap bg-black text-white hover:bg-gray-900 text-lg font-bold px-12 h-16 rounded-xl shadow-2xl transition-all duration-300 hover:scale-105"
              >
                <i className="ri-rocket-line text-2xl"></i>
                Start Your Free Trial Now
                <i className="ri-arrow-right-line text-xl"></i>
              </button>

              <div className="mt-8 flex items-center justify-center gap-6 text-sm text-white/90">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-lg"></i>
                  <span>Secure Setup</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-customer-service-line text-lg"></i>
                  <span>24/7 Support</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-star-line text-lg"></i>
                  <span>Trusted by CPAs</span>
                </div>
              </div>
            </div>
          </div>

          {/* Partnership Note */}
          <div className="mt-12 text-center">
            <p className="text-gray-500 text-sm">
              This exclusive offer is available only to Himalaya community members. Questions? Contact our partnership team for assistance.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
